import EventsDetailTicketSelector from './EventsDetailTicketSelector';
import AdditionalEventsSelector from './AdditionalEventsSelector';
import ContentStorage, { ComponentKeys } from '../../tnew/content/ContentStorage';
import { loadModal } from '../../AsyncLoader';
import dom from '../../utils/dom';
import DomEffects from '../../utils/DomEffects';
import AnalyticsService from '../../analytics/AnalyticsService';

/** @typedef {import('./types').TicketSelectorOptions} TicketSelectorOptions */
/** @typedef {import('./types').PerformanceConfiguration} PerformanceConfiguration */
/** @typedef {import('../../forms/address/types').StateFilterData} StateFilterData */
/** @typedef {import('../../analytics/types').IViewItemAnalytics} IViewItemAnalytics */

/**
 * @param {object} param0
 * @param {string} param0.formSelector
 * @param {TicketSelectorOptions} param0.ticketSelectorOptions
 * @param {boolean} param0.isSeatMapModalVisible
 * @param {PerformanceConfiguration} param0.performanceConfiguration
 * @param {StateFilterData} param0.stateFilterData
 * @param {IViewItemAnalytics} param0.viewItemAnalytics
 */
window.tnew.page.initialize = ({
  formSelector,
  ticketSelectorOptions,
  isSeatMapModalVisible,
  performanceConfiguration,
  stateFilterData,
  viewItemAnalytics,
}) => {
  // Fire view_item event on page load
  if (viewItemAnalytics) {
    AnalyticsService.trackViewItem(viewItemAnalytics);
  }

  const $form = dom.find(formSelector);

  if ($form) {
    const onReservationSuccess = ({ redirectUrl }) => {
      window.location.href = redirectUrl;
    };

    new EventsDetailTicketSelector($form,
      ticketSelectorOptions,
      performanceConfiguration,
      stateFilterData,
      onReservationSuccess);
  }

  dom.findAll('.tn-additional-events').forEach(($el) => AdditionalEventsSelector.setup($el));

  initProductionSeasonDescriptionToggle();

  if (isSeatMapModalVisible) {
    initSeatMapModal();
  }
};

async function initSeatMapModal() {
  const $btn = dom.find('.tn-event-detail__btn-view-seat-map-modal');
  const $dialogBody = dom.find('#tn-event-detail-seat-map-modal-body');

  dom.remove($dialogBody);
  dom.unhide($dialogBody);

  const Modal = await loadModal();

  const { title, labelBtnAccept } = getSeatMapModalProperties();

  $btn.addEventListener('click', () => {
    Modal.alert({
      className: 'tn-ticketing-module-map-modal',
      title,
      labelBtnAccept,
      bodyContents: $dialogBody,
      returnFocusTo: $btn,
    });
  });
}

function getSeatMapModalProperties() {
  const key = ComponentKeys.STATIC_BEST_AVAILABLE;

  return {
    title: ContentStorage.get(key, 'Heading'),
    labelBtnAccept: ContentStorage.get(key, 'SeatMapModalCloseButtonText'),
  };
}

function initProductionSeasonDescriptionToggle() {
  const $button = dom.find('.tn-detail-production-text-toggle-link');

  if ($button) {
    const $contents = dom.find('#tn-detail-production-text-content');
    const $labels = [...$button.children];

    let isExpanded = $button.getAttribute('aria-expanded') === 'true';

    $button.addEventListener('click', () => {
      if (isExpanded) {
        DomEffects.collapse($contents);
      } else {
        DomEffects.expand($contents);
      }

      isExpanded = !isExpanded;

      $button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

      $labels.forEach(($el) => dom.toggle($el));
    });
  }
}
